<template>
  <div style="width: 98%">
    <el-table
      border
      stripe
      :data="tableData.list"
      :row-key="rowKey"
      :height="height"
      @select="handleSelect"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
      ref="multipleTable"
    >
      <slot name="prefix"></slot>
      <el-table-column
        v-for="item in columns"
        :key="item.key ? item.key : item.slot"
        :prop="item.key"
        :label="item.label"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :width="item.width"
        :align="item.align ? item.align : 'left'"
        :show-overflow-tooltip="item['show-overflow-tooltip']"
      >
        <template slot-scope="{ row, $index }">
          <span v-if="item.key">{{ row[item.key] }}</span>
          <slot
            v-if="item.slot"
            :name="item.slot"
            :row="row"
            :index="$index"
          ></slot>
        </template>
      </el-table-column>
      <slot></slot>
    </el-table>
    <el-pagination
      class="pagination-wapper"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
      :current-page="parseInt(tableData.page) || 1"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="parseInt(tableData.size) || 10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="parseInt(tableData.total) || 0"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    rowKey: {
      type: String,
    },
    columns: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      required: true,
      type: Object,
      default() {
        return {
          page: 1,
          size: 10,
          total: 0,
          list: [],
        };
      },
    },
    height: {
      type: String,
    },
  },
  methods: {
    selectInit() {
      //多选类型的表格 清除选择项
      this.$refs.multipleTable.clearSelection();
    },
    handleSizeChange(size) {
      let page = this.tableData.page;
      if (page !== 1) {
        // 当不是在第一页更改size时，更新tableData里面的数据。以防再次触发handleChangePage
        page = 1;
        this.tableData.size = size;
        this.tableData.page = 1;
      }
      this.$emit("page-change", { page, size });
    },
    handleChangePage(page) {
      this.$emit("page-change", { page, size: this.tableData.size });
    },
    handleSelect(selection, row) {
      this.$emit("select", selection, row);
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    handleSortChange(column) {
      this.$emit("sort-change", column);
    },
  },
};
</script>
<style scoped lang="scss">
.pagination-wapper {
  text-align: right;
  margin-top: 10px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  // width: 18px !important;
  height: 15px !important;
}
</style>
